const MAX_SSN_DIGITS = 12;
const SSN_DATE_PART_LENGTH = 8;

export const normalizeSocialSecurityNumber = (
  value: string | null | undefined
): string => (value ?? '').replace(/\D/g, '').slice(0, MAX_SSN_DIGITS);

export const formatSocialSecurityNumber = (
  value: string | null | undefined
): string => {
  const digits = normalizeSocialSecurityNumber(value);
  if (digits.length !== MAX_SSN_DIGITS) {
    return digits;
  }

  return `${digits.slice(0, SSN_DATE_PART_LENGTH)}-${digits.slice(SSN_DATE_PART_LENGTH)}`;
};
